import LogRocket from 'logrocket';
import { User } from 'firebase/auth';
import { EnvString } from '@sworkit/api';

export function initLogRocket(
  env: EnvString,
  release: string
) {
  if (!LogRocket) return;
  if (env === 'prod') {
    // LogRocket.init('iq5ssa/sw-app-prod', {
    //   release,
    //   dom: {
    //     baseHref: 'https://app.sworkit.com/'
    //   }
    // });
    // only init for beta for now
  } else if (env === 'beta') {
    LogRocket.init('iq5ssa/sw-app-beta', {
      release,
      dom: {
        baseHref: 'https://beta.sworkit.com/',
      },
    });
  }
}

export function identifyUserLogRocket(user: User) {
  if (!LogRocket) return;
  LogRocket.identify(user.uid, {
    name: user.displayName,
    email: user.email,
  });
}
